import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { map } from 'rxjs';

import { filterBoolean } from '@core/common-legacy';
import { createActionResponseFactory } from '@core/ngrx-legacy';
import { TellentMembersActions, TellentMembersSelectors } from '@core/tellent-data';
import { TeamMembersStatuses } from '@core/tellent-types';

@Injectable()
export class SelectTeamMembersService {
  private readonly scope = 'select-team-members-dialog';
  private readonly store = inject(Store);
  private readonly actionResponse = createActionResponseFactory(TellentMembersActions);

  public selectTeamMembersPagination = this.store.selectSignal(
    TellentMembersSelectors.pagination({ scope: this.scope }),
  );

  public fetchAndSelectWithPageAndQuery(page: number, query: string, limit: number) {
    return this.actionResponse(
      TellentMembersActions.fetchPaginatedCollection,
      {
        payload: {
          params: {
            statuses: [TeamMembersStatuses.Active],
            scope: this.scope,
            q: query,
            page,
            limit,
          },
        },
      },
      {
        successResponse: () =>
          this.store.select(TellentMembersSelectors.entities({ scope: this.scope })),
      },
    ).pipe(
      map(({ success }) => success),
      filterBoolean,
    );
  }
}
